import { Button, Intent, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, MultiSelect2 } from "@blueprintjs/select";
import _ from "lodash";
import React from "react";
import { UserLanguage } from "../../../lang/lang";
import { FormItemBuilder } from "../Form";

const StringSelect = MultiSelect2.ofType<string>();

const StringItemRenderer: ItemRenderer<string> = (
  str,
  { handleClick, modifiers, query }
) => {
  if (!modifiers.matchesPredicate) return null;

  return (
    <MenuItem
      key={str}
      disabled={modifiers.disabled}
      text={str}
      onClick={handleClick}
    />
  );
};

const RenderCreateStringOption =
  (strings: string[]) =>
  (
    query: string,
    active: boolean,
    handleClick: React.MouseEventHandler<HTMLElement>
  ) =>
    (
      <MenuItem
        icon={strings.indexOf(query) === -1 ? "add" : "cross"}
        text={query}
        active={active}
        disabled={strings.indexOf(query) !== -1}
        intent={strings.indexOf(query) === -1 ? Intent.SUCCESS : Intent.WARNING}
        onClick={handleClick}
        shouldDismissPopover={false}
      />
    );

export const StringListBuilder: FormItemBuilder = (bundle) => {
  console.log("string list builder", bundle);
  let current = bundle.form_state.values[bundle.field_index];
  let strings: string[] = [];
  if (_.isArray(current)) {
    strings = _.clone(current);
  } else {
    strings = [];
  }

  console.log("strings", strings);

  return (
    <StringSelect
      fill
      itemRenderer={StringItemRenderer}
      items={[]}
      onItemSelect={(i) => {
        if (strings.indexOf(i) === -1) strings.push(i);
        else strings = strings.filter((s) => s !== i);
        bundle.update_value(strings);
      }}
      noResults={
        <MenuItem
          disabled={true}
          text={UserLanguage().data.strings_select_empty}
        />
      }
      placeholder={UserLanguage().data.strings_select_empty}
      tagRenderer={(i) => {
        console.log("Rendering ", i);
        return i;
      }}
      tagInputProps={{
        onRemove: (v) => {
          bundle.update_value(strings.filter((s) => s !== v));
        },
        rightElement:
          strings.length > 0 ? (
            <Button
              icon="cross"
              minimal
              onClick={() => bundle.update_value([])}
            />
          ) : undefined,
        tagProps: {
          intent: Intent.NONE,
        },
      }}
      createNewItemRenderer={RenderCreateStringOption(strings)}
      createNewItemFromQuery={(query) => query}
      selectedItems={strings}
      resetOnSelect
    ></StringSelect>
  );
};
